export default function Solution() {
  const solutions = [
    {
      number: '01',
      icon: 'ri-presentation-line',
      title: '施主様への商談完全代行',
      description: '専門スタッフが施主様への説明・商談を完全代行。太陽光の知識がなくても安心してお任せいただけます。',
      color: 'from-teal-400 to-emerald-400',
      bgColor: 'bg-teal-50',
      emoji: '🤝'
    },
    {
      number: '02',
      icon: 'ri-file-chart-line',
      title: '設計・見積もり作成代行',
      description: '図面をいただくだけで、最適なシステム設計と詳細見積もりを作成。面倒な計算や資料作成は不要です。',
      color: 'from-emerald-400 to-green-400',
      bgColor: 'bg-emerald-50',
      emoji: '📐'
    },
    {
      number: '03',
      icon: 'ri-government-line',
      title: '補助金申請の完全代行',
      description: '煩雑な補助金申請書類の作成から提出まで完全代行。最新の補助金情報も随時ご提供いたします。',
      color: 'from-cyan-400 to-teal-400',
      bgColor: 'bg-cyan-50',
      emoji: '📝'
    },
    {
      number: '04',
      icon: 'ri-tools-line',
      title: '施工・工事の完全対応',
      description: '経験豊富な施工チームが責任を持って工事を実施。工務店様は現場管理の手間なく安心です。',
      color: 'from-green-400 to-emerald-400',
      bgColor: 'bg-green-50',
      emoji: '🔧'
    },
    {
      number: '05',
      icon: 'ri-shield-check-line',
      title: 'アフターフォロー完備',
      description: 'メンテナンス事業も自社運営。施工後のクレーム対応やメンテナンスも全てお任せください。',
      color: 'from-teal-400 to-cyan-400',
      bgColor: 'bg-teal-50',
      emoji: '🛡️'
    }
  ];

  return (
    <section id="solution" className="py-12 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-400 to-emerald-400 text-white px-5 py-2 md:px-8 md:py-3 rounded-full text-sm md:text-lg font-bold mb-4 md:mb-6 shadow-lg">
            <i className="ri-hand-heart-line text-lg md:text-xl"></i>
            丸投げOK！
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-3 md:mb-4">
            太陽光発電販売を<span className="text-teal-500">丸投げ代行</span>
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-3xl mx-auto mt-3 md:mt-4">
            商談から施工、アフターフォローまで全てお任せ。工務店様は案件を紹介するだけで収益化できます。
          </p>
          <div className="w-16 md:w-20 h-1 md:h-1.5 bg-gradient-to-r from-teal-400 to-emerald-400 mx-auto mt-4 md:mt-6 rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {solutions.map((solution, index) => (
            <div 
              key={index}
              className={`bg-white rounded-2xl md:rounded-3xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-teal-200 hover:-translate-y-1 cursor-pointer ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`}
            >
              <div className={`${solution.bgColor} p-4 md:p-6 relative`}>
                <div className="absolute top-3 md:top-4 right-3 md:right-4 text-gray-300/50 text-4xl md:text-5xl font-bold">
                  {solution.number}
                </div>
                <div className="relative z-10 flex items-center gap-3 md:gap-4">
                  <div className={`w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br ${solution.color} rounded-xl md:rounded-2xl flex items-center justify-center shadow-md`}>
                    <span className="text-2xl md:text-3xl">{solution.emoji}</span>
                  </div>
                  <h3 className="text-base md:text-xl font-bold text-gray-800">
                    {solution.title}
                  </h3>
                </div>
              </div>
              <div className="p-4 md:p-6">
                <p className="text-gray-600 leading-relaxed text-xs md:text-sm">
                  {solution.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-16 bg-gradient-to-r from-teal-50 to-emerald-50 rounded-2xl md:rounded-3xl p-6 md:p-10 text-center border border-teal-100">
          <div className="flex items-center justify-center gap-2 md:gap-3 mb-3 md:mb-4">
            <span className="text-3xl md:text-4xl">💡</span>
            <h3 className="text-lg md:text-3xl font-bold text-gray-800">
              工務店様の負担ゼロで、太陽光発電事業を収益化
            </h3>
          </div>
          <p className="text-gray-600 text-sm md:text-base max-w-3xl mx-auto leading-relaxed">
            専門知識や施工体制がなくても大丈夫。案件をご紹介いただくだけで、<br className="hidden md:block" />
            商談から施工、アフターフォローまで全てライズが代行いたします。
          </p>
        </div>
      </div>
    </section>
  );
}